// extracted by mini-css-extract-plugin
module.exports = {"crop_center":"ResponsiveImage_crop_center__vZzhx","desktopImage":"ResponsiveImage_desktopImage__sX0JV","mobileImage":"ResponsiveImage_mobileImage__P4O1N"};